export default "__VITE_ASSET__jsFv0aIp__"